import type { QrCodeSettings } from '../../../../../../shared/types';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_QR_CODE_CUSTOMIZATION = 'UPDATE_QR_CODE_LINK_QR_CODE_CUSTOMIZATION' as const;

export const updateQrCodeLinkQrCodeCustomization = (qrCodeCustomization: QrCodeSettings) => ({
  data: { qrCodeCustomization },
  type: UPDATE_QR_CODE_LINK_QR_CODE_CUSTOMIZATION,
});

export type UpdateQrCodeLinkQrCodeCustomizationResponseAction = DataAction<
  typeof UPDATE_QR_CODE_LINK_QR_CODE_CUSTOMIZATION,
  { qrCodeCustomization: QrCodeSettings }
>;
